module.exports = __webpack_public_path__ + "img/01_mov.076e9044.webp";